// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"ed35c17d","348":"4ba7da45","546":"a7535dd6","558":"8a5577aa","571":"24cd8721"}[chunkId] + ".chunk.js";
};